import { render, staticRenderFns } from "./Newaccount.vue?vue&type=template&id=e7a8ebf0&scoped=true"
import script from "./Newaccount.vue?vue&type=script&lang=js"
export * from "./Newaccount.vue?vue&type=script&lang=js"
import style0 from "./Newaccount.vue?vue&type=style&index=0&id=e7a8ebf0&prod&scoped=true&lang=scss"
import style1 from "./Newaccount.vue?vue&type=style&index=1&id=e7a8ebf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a8ebf0",
  null
  
)

export default component.exports